"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBackdrop = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../Backdrop/index.js");
const index_js_2 = require("../utils/index.js");
const DialogContext_js_1 = require("./DialogContext.js");
const classnames_1 = __importDefault(require("classnames"));
/**
 * Backdrop component for dialog. Recommended to be used with `Dialog`
 * then its visibility is being controlled by dialog's `isOpen` prop.
 * @example
 * <Dialog.Backdrop />
 */
exports.DialogBackdrop = React.forwardRef((props, ref) => {
    const dialogContext = (0, DialogContext_js_1.useDialogContext)();
    const { isVisible = dialogContext.isOpen, isDismissible = dialogContext.isDismissible, onClose = dialogContext.onClose, closeOnExternalClick = dialogContext.closeOnExternalClick, relativeTo = dialogContext.relativeTo, onMouseDown, className, style, ...rest } = props;
    const backdropRef = React.useRef(null);
    const refs = (0, index_js_2.useMergedRefs)(backdropRef, ref);
    const handleMouseDown = (event) => {
        // Prevents React from resetting its properties
        event.persist();
        if (event.target !== backdropRef.current) {
            return;
        }
        if (isDismissible && closeOnExternalClick && onClose) {
            onClose(event);
        }
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
    };
    return (React.createElement(index_js_1.Backdrop, { isVisible: isVisible, className: (0, classnames_1.default)({
            'iui-backdrop-fixed': relativeTo === 'viewport',
        }, className), ref: refs, onMouseDown: handleMouseDown, style: {
            pointerEvents: 'auto',
            ...style,
        }, ...rest }));
});
exports.default = exports.DialogBackdrop;
